module.exports = __webpack_public_path__ + "static/media/P1.897bb48a.png";